import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';
import NostroList from './list';

import cn from './styles.module.css';

const Nostro = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const {
    activePermissions,
    pspPartnerAccounts,
    countries,
    currencies,
    baseCurrency,
    accounts,
  } = useAppSelector((state) => state.transactionsDictionaries);
  const { values: transactionsTypes } = useAppSelector(
    (state) => state.settings.transactionsTypes,
  );

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.TRANSACTIONS_NOSTRO_LIST)
    ) {
      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!accounts) {
        getDictionaries();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    pspPartnerAccounts,
    countries,
    currencies,
    baseCurrency,
    accounts,
  ]);

  useEffect(() => {
    let title = 'Nostro transfers';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.nostroLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && transactionsTypes) {
    if (
      activePermissions.includes(PermissionEnum.TRANSACTIONS_NOSTRO_LIST) &&
      transactionsTypes?.find((item) => item.name === 'NOSTRO')?.active
    ) {
      content = (
        <div className={cn.nostro}>
          <NostroList />
          <Outlet />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Nostro;
